import type { BankQuestionOption, TimelineTopicItem } from '../types/topicQuiz';

export type { TimelineTopicItem };

/** Empty until a question-bank API is wired. */
export const questionBankOptions: BankQuestionOption[] = [];

export type TopicFilterValue = 'all' | number;
export type DifficultyFilter = 'all' | BankQuestionOption['difficulty'];

export function getPlannerTopicFilters(topics: TimelineTopicItem[]) {
  return [
    { id: 'all' as const, label: 'All Topics' },
    ...topics.map((t) => ({
      id: t.index as number,
      label: `Topic ${String(t.index).padStart(2, '0')}: ${t.title}`,
    })),
  ];
}

export function getQuestionsForTopic(topicIndex: number): BankQuestionOption[] {
  return questionBankOptions.filter((q) => q.topicIndex === topicIndex);
}

export { calcSessionDuration, formatDurationMinutes } from '../types/topicQuiz';
